module.exports = __webpack_public_path__ + "static/img/4.d391415.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/4.png
// module id = LZN+
// module chunks = 0